import { render, staticRenderFns } from "./contract-form.vue?vue&type=template&id=596941e1&scoped=true&"
import script from "./contract-form.vue?vue&type=script&lang=ts&"
export * from "./contract-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596941e1",
  null
  
)

export default component.exports